import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export const Lightbox = ({ items, index, onClose, onNav }) => {
  const open = index !== null && index >= 0;

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNav(1);
      if (e.key === "ArrowLeft") onNav(-1);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose, onNav]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[90] flex items-center justify-center bg-ink/90 backdrop-blur-sm p-4"
          onClick={onClose}
          data-testid="lightbox"
          role="dialog"
          aria-modal="true"
        >
          <button
            onClick={onClose}
            aria-label="Fechar"
            data-testid="lightbox-close"
            className="absolute right-5 top-5 z-10 rounded-full bg-white/10 p-3 text-white transition-colors hover:bg-white/25"
          >
            <X className="w-5 h-5" />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onNav(-1); }}
            aria-label="Anterior"
            data-testid="lightbox-prev"
            className="absolute left-3 sm:left-8 z-10 rounded-full bg-white/10 p-3 text-white transition-colors hover:bg-white/25"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <motion.figure
            key={index}
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="max-h-[85vh] max-w-4xl"
            onClick={(e) => e.stopPropagation()}
          >
            {items[index].video ? (
              <video
                src={items[index].video}
                controls
                autoPlay
                loop
                playsInline
                className="max-h-[76vh] w-auto max-w-full rounded-xl shadow-2xl"
              />
            ) : (
              <img
                src={items[index].img}
                alt={items[index].caption || ""}
                className="max-h-[76vh] w-auto max-w-full rounded-xl object-contain shadow-2xl"
              />
            )}
            {items[index].caption && (
              <figcaption className="mt-4 text-center font-serif text-lg italic text-cream/90">
                {items[index].caption}
              </figcaption>
            )}
          </motion.figure>
          <button
            onClick={(e) => { e.stopPropagation(); onNav(1); }}
            aria-label="Seguinte"
            data-testid="lightbox-next"
            className="absolute right-3 sm:right-8 z-10 rounded-full bg-white/10 p-3 text-white transition-colors hover:bg-white/25"
          >
            <ChevronRight className="w-6 h-6" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Lightbox;
